export default __webpack_public_path__ + "static/media/glitch33.16ab4d69.png";